import Evaluate from './Evaluate';
export default Evaluate;